<template>
  <div>
    <loading v-if="isLoading" :isLoading="isLoading"></loading>
    <bread-crumb :routeName="'About Us'"></bread-crumb>
    <hero :backgroundImage="slide_image + ''" :content="slide_label"> </hero>
    <div class="container">
      <section class="has-primary-background section">
        <div class="columns">
          <div
            class="column is-4"
            :class="{ 'm-b-50': $mq.resize && $mq.above($mv.tablet) }"
          >
            <h2 class="title is-red is-3">
              {{ mission_label }}
            </h2>
          </div>
          <div class="column">
            <p class="subtitle is-white is-5">
              {{ mission }}
            </p>
          </div>
        </div>
        <div class="columns is-variable is-9">
          <div class="column is-4">
            <h2 class="title is-red is-3">
              {{ our_services_label }}
            </h2>
          </div>
          <div class="column">
            <ul>
              <li
                class="subtitle is-white is-5 m-b-5 m-t-5"
                v-for="service in our_services"
              >
                {{ service.value }}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <div class="section-image" :style="{ background: middle_image }"></div>
    <div class="has-white-background">
      <div class="container">
        <section class="has-white-background section">
          <div class="columns">
            <div class="column is-4">
              <h2 class="title is-red is-3">Our Customers</h2>
            </div>
            <div class="column">
              <p class="subtitle is-5">
                {{ our_customers }}
              </p>
            </div>
          </div>
          <div
            class="columns is-paddingless is-marginless is-gapless is-mobile"
          >
            <div class="column flex is-vertically-centered">
              <icon
                @click.native="prev"
                scale="2"
                class="is-hoverable"
                :class="{ gray: false }"
                name="chevron-left"
              ></icon>
            </div>
            <carousel
              ref="carousel"
              class="column is-10"
              navigationNextLabel=">"
              navigationPrevLabel="<"
              :navigationEnabled="false"
              :paginationEnabled="false"
              :per-page="2"
              :perPageCustom="[[770, 4]]"
              :navigateTo="0"
              :paginationSize="15"
              :paginationActiveColor="'white'"
              :paginationColor="'gray'"
            >
              <slide v-for="customer in customers">
                <figure class="image">
                  <img
                    class="customer-image"
                    :src="`https://${baseURL()}${customer.value.path}`"
                    :alt="customer.value.title"
                    :title="customer.value.title"
                  />
                </figure>
              </slide>
            </carousel>
            <div class="column flex is-vertically-centered">
              <icon
                @click.native="next"
                scale="2"
                class="is-hoverable"
                :class="{ gray: false }"
                name="chevron-right"
              ></icon>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="container">
      <section class="has-primary-background section">
        <div class="columns">
          <div class="column is-4">
            <h2 class="title is-red is-3">
              {{ letter_label }}
            </h2>
          </div>
          <div class="column">
            <p class="subtitle is-white is-5 m-b-15" v-html="letter"></p>
            <p class="title m-b-5 m-t-15 is-white is-4">
              {{ letter_signature }}
            </p>
            <p class="title m-t-5 is-red is-5">Chief Excutive Officer</p>
          </div>
        </div>
      </section>
    </div>
    <!-- <div class="relative"> -->
    <!-- <hr> -->
    <!-- <p class="overlay absolute is-white">Want to learn more?</p> -->
    <!-- </div> -->
    <!-- <div class="columns padding has-primary-background">
            <div class="column">
                <div class="title is-4 is-red">
                    Lorem, ipsum dolor.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
            </div>
            <div class="column">
                <div class="title is-4 is-red">
                    Lorem, ipsum dolor.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
            </div>
            <div class="column">
                <div class="title is-4 is-red">
                    Lorem, ipsum dolor.
                </div>
                <div class="subtitle is-white m-t-5 is-5">
                    <icon name="chevron-right" class="is-red"></icon>
                    Lorem ipsum dolor sit amet consectetur.
                </div>
            </div>
            <div class="column has-gradient-background">
                <p class="subtitle is-4 is-white">
                    Lorem, ipsum dolor sit amet consectetur adipisicing.
                </p>
                <button class="button is-fullwidth is-red">Lorem, ipsum.</button>
            </div>
        </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      letter: " ",
      letter_label: " ",
      letter_signature: " ",
      middle_image: "#",
      mission: " ",
      mission_label: " ",
      our_customers: " ",
      our_services: " ",
      our_services_label: " ",
      slide_image: "#",
      slide_label: " ",
      customers: [],
      loading: 0,
      loaded: 0,
      isLoading: false,
    };
  },
  methods: {
    next() {
      const carousel = this.$refs["carousel"];
      const currentPage = carousel.currentPage;
      const pageCount = carousel.pageCount;
      // currentPage , pageCount
      // if (this.$refs.carousel.currentPage < ( this.$refs.carousel.pageCount - 1) ) {
      currentPage < pageCount - 1
        ? carousel.goToPage(currentPage + 1)
        : carousel.goToPage(0);
      // }
    },
    prev() {
      const carousel = this.$refs["carousel"];
      const currentPage = carousel.currentPage;
      const pageCount = carousel.pageCount;
      // currentPage , pageCount
      // if (this.$refs.carousel.currentPage > 0) {
      currentPage != 0
        ? carousel.goToPage(currentPage - 1)
        : carousel.goToPage(pageCount - 1);
      // }
    },
  },
  mounted() {
    // this.$refs.carousel.currentPage - 1;
  },
  created() {
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/about?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        // localStorage.setItem('about', JSON.stringify(data.data));
        this.letter = data.data["letter"];
        this.letter_label = data.data["letter_label"];
        this.letter_signature = data.data["letter_signature"];
        this.middle_image = `url(https://${this.baseURL()}${
          data.data["middle_image"]["path"]
        })`;
        this.mission = data.data["mission"];
        this.mission_label = data.data["mission_label"];
        this.our_customers = data.data["our_customers"];
        this.customers = data.data["customers"];
        this.our_services = data.data["our_services"];
        this.our_services_label = data.data["our_services_label"];
        this.slide_image = `https://${this.baseURL()}${
          data.data["slide_image"]["path"]
        }`;
        this.slide_label = data.data["slide_label"];
        // subscribe to loading event to know how many images are loading
        this.$on("loading", () => {
          this.isLoading = true;
          this.loading++;
        });

        // detect when loading is finished
        this.$on("loaded", () => {
          this.loaded++;
          // working dynamically regardless of how many images are on page!
          if (this.loaded === this.loading) this.isLoading = false;
        });
      });
  },
};
</script>

<style lang="scss" scoped>
// .has-gradient-background {
//     position: relative;
//     top: 30px;
//     padding: 2.5rem;
// }
.section-image {
  height: 50vh;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
}
.image {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.customer-image {
  max-height: 150px;
  width: auto;
}
.overlay {
  &:before {
    content: "";
    width: 20px;
    height: 29px;
    background: black;
    top: 0px;
    right: 30px;
  }
}
hr {
  background-color: white;
  border: none;
  display: block;
  height: 1px;
  margin: 0px;
}
ul {
  list-style-type: disc;
  li {
    // list-style: ;
    display: list-item;
  }
  margin-left: 20px !important;
}
figure {
  img {
    max-height: 100px;
  }
}
.gray {
  color: gray !important;
}
</style>



// WEBPACK FOOTER //
// about.vue?61036d3c